export default __webpack_public_path__ + "static/media/connect.4e3284b4.png";